import apiClient from './_axios';
import type { RoutersReady } from './freePromo';

/** Owner's scrolling portal announcement (Ray 2026-10-23), per main vendo. */
export interface Announcement {
   deviceId: string;
   name: string;
   text: string;
   until: string | null;
   /** Owner colours '#rrggbb' ('' = match the portal). */
   bg?: string;
   fg?: string;
   /** live = customers see it · pending = router not confirmed yet ·
    *  offline = router not checking in · update = firmware too old */
   state?: 'live' | 'pending' | 'offline' | 'update';
}

export async function listAnnouncements(): Promise<{ announcements: Announcement[]; routers: RoutersReady }> {
   const r = await apiClient.get<{ announcements: Announcement[]; routers?: RoutersReady }>('/vendo/announcements');
   return {
      announcements: r.data.announcements,
      routers: r.data.routers ?? { ready: 0, waiting: 0, waitingNames: [], waitingVersions: [] },
   };
}

/** text '' removes it from those vendos; until null = until removed. */
export async function setAnnouncement(body: {
   deviceIds: string[];
   text: string;
   until: string | null;
   bg?: string;
   fg?: string;
}): Promise<unknown> {
   const r = await apiClient.put('/vendo/announcements', body);
   return r.data;
}
